import styled from 'styled-components';

const PopupWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  background-color: var(--background-color);
  color: var(--font-on-background-color);
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  @media (max-width:600px) {
    top: 0;
    left: 0;
    padding:0;
    transform: translate(2.5%, 2.5%);
    overflow-y:auto;
    width:95%;
    height:95%;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: var(--primary-color);
  font-weight: bold;
`;

const Popup = ({ children,closePopup }) => {
    const handleClick = (e) => {
        if (!e.target.closest('button')) {
            e.stopPropagation(); // Prevent propagation only if not clicking a button
        }
    };
    return (
        <PopupWrapper onClick={handleClick}>
            <CloseButton onClick={closePopup}>X</CloseButton>
            {children}
        </PopupWrapper>
    );
};
export default Popup;